import React, { Component } from 'react';

class Nav extends Component {
  render() {
    return (
        <nav id="nav">
          {/* <ul>
            <li><a href="index.html">Home</a></li>
            <li>
              <a href="#" className="icon fa-angle-down">Services</a>
              <ul>
                <li><a href="#">Fiber Internet</a></li>
                <li><a href="#">Television</a></li>
                <li><a href="#">Telephone</a></li>
                <li>
                  <a href="#" className="icon fa-angle-left">  Bundles</a>
                  <ul>
                    <li><a href="#">Double Play</a></li>
                    <li><a href="#">Triple Play</a></li>
                  </ul>
                </li>
              </ul>
            </li>
            <li>
              <a href="#" className="icon fa-angle-down">Sign Up</a>
              <ul>
                <li><a href="#">Check your address</a></li>
                <li><a href="#">Sign up form</a></li>
              </ul>
            </li>
            <li>
              <a href="#" className="icon fa-angle-down">About</a>
              <ul>
                <li><a href="#">Board of Directors</a></li>
                <li><a href="#">Management</a></li>
                <li><a href="#">Careers</a></li>
                <li><a href="#">Office</a></li>
                <li><a href="#">Contact</a></li>
              </ul>
            </li>
          </ul> */}
        </nav>
    );
  }
}

export default Nav;


// WEBPACK FOOTER //
// ./src/components/Nav.js